import { useStore } from '@app/store/useStore.hook';
import { sleep } from '@app/utils/async.utils';
import { useEffect } from 'react';

const POLLING_DELAY_MS = 2e3;

export const TrialOnboardingScanPolling: React.FC = () => {
  const getMe = useStore.useGetMe();

  useEffect(() => {
    let isMounted = true;
    let power = 500;

    const loop = async () => {
      if (!isMounted) {
        return;
      }
      if (power < 1) {
        return;
      }
      power--;
      try {
        await getMe();
      } catch {
        // just ignore errors if any
      }
      await sleep(POLLING_DELAY_MS);
      await loop();
    };

    loop();

    return () => {
      isMounted = false;
    };
  }, [getMe]);

  return null;
};
